//We should be able to remove date-fns-tz when this is done. https://github.com/date-fns/date-fns/issues/873
import { format } from 'date-fns-tz';
import { fromUnixTime } from 'date-fns';

export const safeFromUnixTime = timestamp => {
    let date = new Date();
    if (!timestamp) return date;
    try {
        date = fromUnixTime(timestamp);
    } catch (error) {
        console.log(error);
    }
    return date;
};

export const catalogLongCardDate = timestamp => format(safeFromUnixTime(timestamp), 'eee, MMM dd, yyyy h:mm a zz');

export const catalogCardDate = timestamp => format(safeFromUnixTime(timestamp), 'MMM dd, yyyy h:mm a zz');

export const errorDate = timestamp => format(safeFromUnixTime(timestamp), 'MMM do, yyyy h:mm a zz');

export const formatLongDate = timestamp => format(safeFromUnixTime(timestamp), 'MMMM do, yyyy zz');

export const formatShortDate = timestamp => format(safeFromUnixTime(timestamp), 'MMMM do, yyyy');

export const formatShorterDate = timestamp => format(safeFromUnixTime(timestamp), 'MMM dd, yyyy');

export const formatShortDateDay = timestamp => format(safeFromUnixTime(timestamp), 'eee, MMM dd, yyyy');

export const formatShortTimeOnly = timestamp => format(safeFromUnixTime(timestamp), 'h:mm a zz');
